module.exports = __webpack_public_path__ + "static/media/out.40f3cff4.mp3";